// src/OfflinePage.js
import React from 'react';
import noconnect from '../../assets/noconnect.jpg'

const OfflinePage = () => (
    <div className="offline-container">
    <img src={noconnect} alt="No Internet Connection" className="offline-image" />
    <h1>You're Offline</h1>
    <p>Please check your internet connection and try again.</p>
  </div>
);

export default OfflinePage;